export function castIfNumeric(
  value: string | number | undefined,
  fallback?: undefined
): number | undefined;
export function castIfNumeric(
  value: string | number | undefined,
  fallback: number
): number;
export function castIfNumeric(
  value: string | number | undefined,
  fallback?: number
) {
  if (typeof value !== "undefined" && isNumeric(value)) {
    return +value;
  }

  return fallback;
}

export function isNumeric(value: string | number | undefined) {
  if (typeof value === "number") return true;
  if (value && !Number.isNaN(+value)) {
    return true;
  }

  return false;
}
